/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function ContentCategoriesSearchViewComponent (
    this: JS5Object,
    _: JS5Object,
    $q: JS5Object,
    $routeParams: JS5Object,
    BreadcrumbService: JS5Object,
    ContentEditService: JS5Object,
    ContentResourceFactory: JS5Object,
    SubscriptionsResourceFactory: JS5Object,
    PermissionsService: JS5Object,
    uiGridConstants: JS5Object
) {

    //======//
    // Grid //
    //======//

    let gridColumns: JS5Object = [
        {
            field: 'category.name',
            displayName: 'Category',
            maxWidth: 325,
            sort: {
                direction: uiGridConstants.ASC,
                priority: 1
            },
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'category.type.name',
            displayName: 'Category Type',
            maxWidth: 325,
            sort: {
                direction: uiGridConstants.ASC,
                priority: 2
            },
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'commercialBlackTimingRequired',
            displayName: 'Commercial Black TCs',
            maxWidth: 300,
            cellTemplate: 'components/visual/grid/radio-button-template.html'
        },
        {
            field: 'liveClippingEnabled',
            displayName: 'Live Clipping',
            maxWidth: 300,
            cellTemplate: 'components/visual/grid/radio-button-template.html'
        },
        {
            field:'hidden',
            displayName: 'Has No Subscriptions',
            enableHiding: false,
            visible: false,
            maxWidth: 30,
            cellTemplate: '<span></span>',
            suppressRemoveSort: true,
            sort: {
                direction: uiGridConstants.ASC,
                priority: 0
            }
        }
    ];

    this.currentGridOptions = {
        rowSelection: false,
        enableRowHeaderSelection: false,
        enableSelectAll: false,
        enableColumnResizing: true,
        enablePaginationControls: false,
        useExternalPagination: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        rowHeight: 26,
        multiSelect: false,
        enableVerticalScrollbar: 2,
        columnDefs: gridColumns,
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
        onRegisterApi: (gridApi: JS5Object) => {
            this.gridApi = gridApi;
        }
    };

    this.onRowDblClick = (row: JS5Object) => {
        ContentEditService.openContentCategoryEditView(row.entity);
    };


    //=========//
    // Toolbar //
    //=========//

    this.toolbarButtonDefs = [{
        label: 'New',
        enabled: () => true,
        onClick: () => ContentEditService.showNewContentCategoryModal()
    }];

    //================//
    // Data Retrieval //
    //================//

    const getFilledCategoriesPromise = (contentId: string, contentCategories: JS5Object[]) => {
        let requests: JS5Object = {};
        _.forEach(contentCategories, (contentCategory: JS5Object) => {
            requests[contentCategory.id] = SubscriptionsResourceFactory.getSubscriptionsByContentCategory(
                {
                    contentId: contentId,
                    categoryId: contentCategory.category.id,
                    fetchLimit: 1,
                    fetchOffset: 0,
                    includeDisabled: false,
                    includeEnabled: true,
                    searchString: ''
                },
                (subscriptions: JS5Object[]) => {
                    return subscriptions;
                }
            ).$promise.then(
                (subscriptions: JS5Object[]) => {
                    return _.size(subscriptions) >= 1;
                });
        });

        return $q.all(requests);
    };

    const getCategoryStyles = (contentCategories: JS5Object[]) => {
        return getFilledCategoriesPromise($routeParams.id, contentCategories)
            .then((filledCategoryIds: string[]) => {
                _.forEach(contentCategories, (category: JS5Object) => {
                    category.hidden = !filledCategoryIds[category.id];
                });
                return contentCategories;
            });
    };

    this.queryForGridData = () => {
        this.loadingIndicator.show = true;
        let systemOpsPromise = PermissionsService.isSystemOperator()
            .then((isSystemOperator: boolean) => {
                if (!isSystemOperator) {
                    _.remove(gridColumns, {field: 'liveClippingEnabled'});
                }
            });
        let dataPromise = ContentResourceFactory.getContentCategories({
            id: $routeParams.id
        }).$promise
            .then(getCategoryStyles)
            .then((contentCategories: JS5Object[]) => {
                this.currentGridOptions.data = contentCategories;
            });
        $q.all([
            systemOpsPromise,
            dataPromise
        ]).then(() => {
            this.loadingIndicator.show = false;
        });
    };

    //=================//
    // Lifecycle Hooks //
    //=================//

    this.$onInit = () => {
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        this.queryForGridData();
    };

    this.$onChanges = () => {
        if (this.editorForm) {
            ContentEditService.editorForm = this.editorForm;
        }
    };
}

angular.module('prism-ui.content').component(
    'contentCategoriesSearchView',
    {
        bindings: {
            contentObject: '='
        },
        controller: ContentCategoriesSearchViewComponent,
        templateUrl: 'meta/content/editor/components/view/categories/searchView/content-categories-searchview-template.html'
    });
